import $ from 'jquery';
import { SharedService } from './../../../services/shared.service';
import { MediaMatcher } from '@angular/cdk/layout';
import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    ViewChild,
    OnInit
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { routerTransition } from '../../shared/animations';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-full-layout',
    templateUrl: 'full.component.html',
    styleUrls: ['./full.component.scss'],
    providers: [MatBottomSheet],
    animations: [routerTransition]
})
export class FullComponent implements OnDestroy, OnInit {

    @ViewChild('snav', { static: true }) public snav: MatSidenav;

    mobileQuery: MediaQueryList;
    minisidebar: boolean;
    showHide: boolean;
    sidebarOpened: boolean;

    public config: PerfectScrollbarConfigInterface = {};
    private _mobileQueryListener: () => void;

    constructor(
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        public dialog: MatDialog,
        public sharedService: SharedService,

    ) {
        this.mobileQuery = media.matchMedia('(min-width: 768px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
    }

    ngOnInit() {
        this.sharedService.sideNav = this.snav;//
    }

    getState(outlet: RouterOutlet) {
        return outlet.activatedRouteData?.rState;
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }
}
